import { ReducerTypes } from './enum'

export interface SessionData {
  id: number
  isOverridden: boolean
  productType: string
  listSubModels: ListSubModel[]
  physicalMaterial: string
  vector: string
  viralTiter: string
  volume: string
  aliquoting: string
  amount: string
  lentiviralBackbone: string
  format: string
  pageNo: number
  purification: string
  structure: string
  modification: string
  scale: string
  species: string
  price: string | null | undefined
  currencySymbol: string | null | undefined
  currency: string | null | undefined
  listPhysicalMaterials: string[]
  listVectors: string[]
  listAmount: string[]
  listLentiviralBackbones: string[]
  listViralTiters: string[]
  listVolumes: string[]
  listAliquotings: string[]
  listPurification: string[]
  listSpecies: string[]
  listScale: string[]
  listModification: string[]
  listStructure: string[]
  material: string
  terms: boolean
  cartId?: string | null | undefined
  itemId?: string | null | undefined
  modifiedSequence: string | null | undefined
  modifiedTechnicalSequence: string | null | undefined
  listCompanionProducts?: any
}

export interface ListSubModel {
  name: string
  geneId?: string
  geneSymbol?: string
  sequence: string
  id: number
  isOverridden: boolean
  baseCount: number
  isCurrentForm: boolean
  listSubModelErrors?: ListError[]
  price: string
  cartId?: string | null | undefined
  itemId?: string | null | undefined
}

export interface CustomCrisprState {
  sessionData: SessionData[]
  currentSubModelIndex: number
  sessionListSubModel: ListSubModel[]
  currentItemErrors: ListError[]
  currentViewItemErrors: ListError[]
  pageError: string
  isDisplayError: boolean
  stepNo: number
  customCrisprIndex: number
  crisprSequenceList: boolean
  companionProducts?: any[] | null | undefined
  validateOnClick: boolean
}

export interface ListError {
  key: string
  value: string
}
export interface ListCompanionProducts {
  key: string
  value: string
}

export interface ContextProps {
  state: CustomCrisprState
  dispatch: ({ type, data }) => void
}

type Action =
  | { type: ReducerTypes.INIT }
  | { type: 'UPDATE_INPUT'; data: SessionData[] }
  | { type: 'UPDATE_CURRENT_INDEX'; data: number }
  | { type: 'UPDATE_LIST_SUB_MODEL'; data: [ListSubModel] }
  | { type: 'UPDATE_ERRORS'; data: ListError[] }
  | { type: 'UPDATE_VIEW_ITEM_ERRORS'; data: ListError[] }
  | { type: 'SET_PAGE_ERROR'; data: string }
  | { type: 'IS_DISPLAY_ERROR'; data: boolean }
  | { type: 'SET_STEP_NO'; data: number }
  | { type: 'UPDATE_CRISPR_CURRENT_INDEX'; data: number }
  | { type: 'CRISPR_SEQUENCE_LIST'; data: boolean }
  | { type: 'SET_COMPANION_PRODUCT_INFORMATION'; data: any[] }
  | { type: 'VALIDATE_ON_CLICK'; data: boolean }

export const initialState: CustomCrisprState = {
  sessionData: [
    {
      id: 1,
      isOverridden: false,
      productType: 'customcrispr',
      terms: false,
      listSubModels: [
        {
          name: '',
          geneId: '',
          geneSymbol: '',
          sequence: '',
          id: 1,
          isOverridden: false,
          baseCount: 0,
          isCurrentForm: true,
          listSubModelErrors: [],
          price: '',
          cartId: '',
          itemId: '',
        },
      ],
      physicalMaterial: '',
      vector: 'LV01',
      viralTiter: '10^6',
      volume: '0.2',
      aliquoting: '1 x 200',
      amount: '1',
      lentiviralBackbone: 'LV01',
      format: 'DRY',
      pageNo: 0,
      purification: '',
      structure: '',
      modification: '',
      scale: '',
      species: 'SPCAS9',
      listVectors: [''],
      listAmount: [''],
      listLentiviralBackbones: [''],
      listViralTiters: [''],
      listVolumes: [''],
      listAliquotings: [''],
      listPhysicalMaterials: [],
      listPurification: [''],
      listSpecies: [''],
      listScale: [''],
      listModification: [''],
      listStructure: [''],
      price: '',
      currencySymbol: '',
      currency: '',
      material: '',
      cartId: '',
      itemId: '',
      modifiedSequence: '',
      modifiedTechnicalSequence: '',
    },
  ],
  currentSubModelIndex: 0,
  sessionListSubModel: [],
  currentItemErrors: [],
  currentViewItemErrors: [],
  pageError: '',
  isDisplayError: false,
  stepNo: 0,
  customCrisprIndex: 1,
  crisprSequenceList: false,
  companionProducts: [],
  validateOnClick: false,
}

export function reducer(
  state: CustomCrisprState,
  action: Action
): CustomCrisprState {
  switch (action.type) {
    case ReducerTypes.INIT:
      return initialState

    case 'UPDATE_INPUT':
      return {
        ...state,
        sessionData: action.data,
      }

    case 'UPDATE_CURRENT_INDEX':
      return {
        ...state,
        currentSubModelIndex: action.data,
      }

    case 'UPDATE_LIST_SUB_MODEL':
      return {
        ...state,
        sessionListSubModel: action.data,
      }

    case 'UPDATE_ERRORS':
      return {
        ...state,
        currentItemErrors: action.data,
      }

    case 'UPDATE_VIEW_ITEM_ERRORS':
      return {
        ...state,
        currentViewItemErrors: action.data,
      }

    case 'IS_DISPLAY_ERROR':
      return {
        ...state,
        isDisplayError: action.data,
      }

    case 'SET_STEP_NO':
      return {
        ...state,
        stepNo: action.data,
      }
    case 'SET_PAGE_ERROR':
      return {
        ...state,
        pageError: action.data,
      }
    case 'UPDATE_CRISPR_CURRENT_INDEX':
      return {
        ...state,
        customCrisprIndex: action.data,
      }
    case 'CRISPR_SEQUENCE_LIST':
      return {
        ...state,
        crisprSequenceList: action.data,
      }
    case 'SET_COMPANION_PRODUCT_INFORMATION':
      return {
        ...state,
        companionProducts: action.data,
      }
    case 'VALIDATE_ON_CLICK':
      return {
        ...state,
        validateOnClick: action.data,
      }
    default:
      return initialState
  }
}
